//Custom components
import type { IType } from '@/api/Rover/types';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../../UI/Card/index.tsx';
import PieChart from '../../../UI/Charts/PieChart';

export interface BreakdownProps {
  title: string;
  breakdownConstruction: IType[];
}

export default function BreakdownConstructionType(props: BreakdownProps) {
  const { title, breakdownConstruction } = props;

  const constructionTypeLabels = breakdownConstruction?.map((data: IType) => data?.constructionType);

  const projectsByConstructionType = breakdownConstruction?.map((data: IType) => {
    return {
      type: data?.constructionType,
      count: data?._count?.constructionType,
    };
  });

  const totalConstructionType = breakdownConstruction?.reduce((acc: number, data: IType) => {
    return acc + data?._count?.constructionType;
  }, 0);

  return (
    <Card title='Construction Type'>
      <div className='relative p-5 h-80'>
        <div className='absolute px-5 text-center'>
          <h3 className='text-gray-500 font-bold'>Total Projects</h3>
          <h1 className='m-0'>{totalConstructionType}</h1>
        </div>
        <div className='md:w-7/8 xl:w-full h-full'>
          <PieChart
            labels={constructionTypeLabels}
            datasets={transformProjectTypeChartDataSets(projectsByConstructionType)}
            chartTitle='Total Project Types'
          />
        </div>
      </div>
    </Card>
  );
}
